export default __webpack_public_path__ + "static/media/bg.e19a8f08.webp";